import type { UseAuth } from '../../hooks/useAuth';
import type { OrderRetrieveResponse } from '../../openapi/types';
import { ORDER_STATE } from '../constants';

export function getOrderDetailAcl(
  hasPermission: UseAuth['hasPermission'],
  order: Pick<OrderRetrieveResponse, 'state'>,
) {
  return {
    canDownloadOrder:
      order.state === ORDER_STATE.PUBLISHED && hasPermission('Orders', 'download', order),
    canEditOrder:
      (order.state === ORDER_STATE.FAILED || order.state === ORDER_STATE.REJECTED) &&
      hasPermission('Orders', 'action.edit', order) &&
      hasPermission('Orders', 'partial_update', order),
    canInterruptProcessing: hasPermission('Orders', 'interrupt_processing', order),
    canRetryProcessing: hasPermission('Orders', 'retry_processing', order),
    canReject: order.state === ORDER_STATE.FAILED && hasPermission('Orders', 'reject', order),
    canEditTaxableSupplyDate:
      order.state === ORDER_STATE.WAITING_FOR_APPROVAL &&
      hasPermission('Orders', 'action.edit_taxable_supply_date', order),
    // Backend přílohy mění v každém stavu objednávky.
    canUploadAttachment: hasPermission('Orders', 'upload_attachment', order),
    canDeleteAttachment: hasPermission('Orders', 'delete_attachment', order),
    ordersActionHiddenCreator: hasPermission('Orders', 'action.hidden_creator', order),
    canSeeLog: hasPermission('Logs', 'retrieve', order),
    // Frontendové policies token k dokladům IPR neznají; backend ho dává rolím s `Orders.create`.
    canDownloadIprDocuments: hasPermission('Orders', 'create', null),
  };
}
